import styles from './FJPrivacySetting.module.less';
import FJUtil from '../../../../util/FJUtil';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../../store/FJLocalStore';
import { SHARE_SETTING_LIST } from '../../../../config/dataConfig/FJCommunityData';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJSingleRadio from '../../../../common/components/FJRadio/FJSingleRadio';
import classNames from 'classnames';
import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { SHARE_LIST } from '../../../../config/dataConfig/FJCommonDataConfig';
import FJButton from '../../../../common/components/FJButton/FJButton';
import FJWarnIcon from '../../../../assets/svg/community/warn.svg?react';
import FJConfig from '../../../../config/FJConfig';
import { PUBLISH_TYPE } from '../../../../config/dataConfig/FJCommunityData';
import FJCommunityUtil from '../../../../util/FJCommunityUtil';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';

const FJPrivacySetting = (props, ref) => {
    const {
        value = PUBLISH_TYPE.PUBLIC,
        onChange,
        renderTrigger,
        onShow,
        onHide,
        placement = 'bottomRight',
        hideShareToSociety = false,
        isTopLayer = false,
        offsetTop = 0,
        shareKey,
        offsetLeft = 0,
        communityId,
        isNeedBindWheelEvent = false,
    } = props;
    const dropdownRef = useRef(null);
    const [currentValue, setCurrentValue] = useState(value);
    const [currentPublicValue, setCurrentPublicValue] = useState(PUBLISH_TYPE.PUBLIC);
    const [loadingType, setLoadingType] = useState('');
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    useEffect(() => {
        if ([PUBLISH_TYPE.PUBLIC, PUBLISH_TYPE.ONLY_PUBLIC].includes(currentValue)) {
            setCurrentPublicValue(currentValue);
        }
    }, [currentValue]);
    useImperativeHandle(ref, () => ({
        getCurrentValue: () => {
            return currentValue;
        },
        hide: () => {
            dropdownRef.current.hide();
        },
    }));
    const isActive = item => {
        if (item.value) {
            return item.value === currentValue;
        } else if (item.values) {
            return item.values.find(valueItem => valueItem.value === currentValue);
        }
    };
    const _onItemClick = (e, item) => {
        e.stopPropagation();
        e.preventDefault();
        _onValueChange(item);
    };
    const _onValueChange = item => {
        const value = item.value || currentPublicValue;
        if (value === currentValue || loadingType) {
            return;
        }
        setLoadingType(item.value);
        onChange &&
            onChange(value, bool => {
                if (bool) {
                    setCurrentValue(value);
                }
                setLoadingType('');
            });
    };
    const forbidEvent = e => {
        FJUtil.forbidEvent(e);
    };

    const _onContactUs = e => {
        FJUtil.forbidEvent(e);
        const shareLink = FJConfig.serverPath + `ai-share/${shareKey}.html`;
        localStorage.setItem('feedback-input', 'Questioned creation link: ' + shareLink);
        window.open(`/contact.html`, '_blank');
    };
    const _onShareToSociety = type => {
        if (!shareKey) return;
        const shareLink = FJUtil.getShareLink(shareKey);
        shareLink && FJUtil.shareToSociety(type, shareLink);
        communityId && FJCommunityUtil.addCommunityBehavior([communityId], 3);
    };

    const _renderOverlay = ({ ref }) => {
        if (value === 'down') {
            return (
                <div className={styles.report_box} ref={ref} onClick={forbidEvent}>
                    <div className={styles.warn_box}>
                        <FJWarnIcon />
                    </div>

                    <div className={styles.title}>{FJLocalStore._('this-creation-was-reported')}</div>
                    <div className={styles.desc}>
                        {FJLocalStore._('this-creation-has-been-reported-and-is-currently-set-to-private')}
                    </div>
                    <FJButton
                        text={FJLocalStore._('contact-us')}
                        type='gradient'
                        className={styles.btn}
                        onClick={_onContactUs}
                    />
                </div>
            );
        }

        return (
            <div className={styles.overlay} ref={ref} onClick={forbidEvent}>
                <div className={styles.title}>{FJLocalStore._('visibility')}</div>
                <div className={styles.content}>
                    {SHARE_SETTING_LIST.map(item => (
                        <FJHoverBoardGradation
                            key={item.name}
                            active={isActive(item)}
                            className={classNames(styles.item, {
                                [styles.item_active]: isActive(item),
                                [styles.disabled]: loadingType && currentValue !== item.value,
                            })}
                            contentClassName={styles.item_inner}
                            hasHover={false}
                            borderWidth={0}
                        >
                            <div
                                className={classNames(styles.inner_box)}
                                onClick={e => {
                                    _onItemClick(e, item);
                                }}
                            >
                                <div className={styles.item_title}>
                                    <div className={styles.item_name}>
                                        {FJLocalStore._(item.name)}
                                        {loadingType === item.value && (
                                            <FJLoading strokeColor='#D2D2DB' style={{ width: 16, height: 16 }} />
                                        )}
                                    </div>
                                    <FJSingleRadio active={isActive(item)} />
                                </div>
                                <div className={styles.item_desc}>{FJLocalStore._(item.desc)}</div>
                                {(item.value === PUBLISH_TYPE.ONLY_PUBLIC || item.value === PUBLISH_TYPE.PUBLIC) &&
                                    currentValue === item.value && (
                                        <div className={styles.public_status_box}>
                                            {!hideShareToSociety && (
                                                <>
                                                    <div className={styles.share_content}>
                                                        {SHARE_LIST.map(item => (
                                                            <div
                                                                key={item.type}
                                                                className={styles.share_img_box}
                                                                onClick={e => {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();
                                                                    _onShareToSociety(item.type);
                                                                }}
                                                            >
                                                                {<item.newIcon />}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}
                            </div>
                        </FJHoverBoardGradation>
                    ))}
                </div>
            </div>
        );
    };
    return (
        <FJDropdownNew
            renderTrigger={renderTrigger}
            renderOverlay={_renderOverlay}
            offsetLeft={offsetLeft}
            offsetTop={offsetTop || 5}
            trigger='click'
            triggerClick={forbidEvent}
            placement={placement}
            useAnchorBody
            zIndex={FJUtil.isLandingPage() ? 4 : 9999}
            canTriggerActive
            isNeedBindWheelEvent={isNeedBindWheelEvent}
            level={1}
            onShow={onShow}
            onHide={onHide}
            isTopLayer={isTopLayer}
            ref={dropdownRef}
            fitInViewAnyway={true}
        />
    );
};

FJPrivacySetting.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    renderTrigger: PropTypes.func,
    shareToSociety: PropTypes.func,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    placement: PropTypes.string,
    hideShareToSociety: PropTypes.bool,
    isTopLayer: PropTypes.bool,
    offsetTop: PropTypes.number,
    shareKey: PropTypes.string,
    offsetLeft: PropTypes.number,
    communityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isNeedBindWheelEvent: PropTypes.bool,
};
export default forwardRef(FJPrivacySetting);
